import Api from '@common/services/api';

export type CompleteEvaluationPayload = {
  submissionStatus: 'completed';
};

export const completeEvaluation = async (
  organisationId: string,
  evaluationId: string,
  payload: CompleteEvaluationPayload
) => {
  return Api.post(
    `/v1/organisations/${organisationId}/performance/evaluations/${evaluationId}/complete`,
    payload
  );
};

